// Set by the auth screen when someone chooses "Continue with university email",
// read by Onboarding. Lets onboarding tell a person who took the university
// route but signed up with a non-university address that they're set up as
// normal. UX only — university STATUS is decided server-side from the
// Cognito-verified email, never from this flag.
export const SIGNUP_PATH_KEY = 'pm-signup-path';
